const desktop = theme => {
  const {toVW} = theme;
  return {
    chip: {
      marginBottom: -12,
      width: 14.5,
      height: 'auto',
    },
  };
};

const mobile = theme => {
  const {toVW} = theme;
  return {
    chip: {
      marginBottom: -16,
      width: 19.5,
      height: 'auto',
    },
    chipColumn: {
      display: 'flex',
      flexDirection: 'column',
    },
    chipsContainer: {
      display: 'flex',
      flexDirection: 'row',
      // alignItems:'end'
    },
  };
};

const styles = theme => {
  const {currentStyleFormat, commonClass, classesMerge} = theme;
  let mergedClass = classesMerge(commonClass, mobile(theme));
  if (currentStyleFormat?.id === 'desktop') {
    mergedClass = classesMerge(mergedClass, desktop(theme));
  }
  return mergedClass;
};

export default styles;
